/** Which of the report form's three screens is showing. */
export enum ReportStep {
  Riders = "riders",
  Details = "details",
  Confirm = "confirm",
}
